import {
  Command,
  type ModelSchemaContext,
  type ModelItem,
  type ModelPosition,
  type ModelSchemaContextDefinition,
  Editor,
} from 'ckeditor5';
import {
  TemplateFieldDTO,
} from 'dtos';

type SchemaContextDefinition = ModelItem
| ModelPosition
| ModelSchemaContext
| ModelSchemaContextDefinition;

export default class FieldCommand extends Command {
  private everFocused = false;

  constructor(editor: Editor) {
    super(editor);
    editor.editing.view.document.once('focus', () => {
      this.everFocused = true;
    });
  }

  execute(value: TemplateFieldDTO) {
    const { model } = this.editor;
    const { selection } = model.document;

    model.change((writer) => {
      if (!this.everFocused) {
        const root = (model.document.getRoot as any)?.('content');
        const insertAt = writer.createPositionAt(root, 'end');
        writer.setSelection(insertAt);
      }

      const field = writer.createElement('field', {
        ...Object.fromEntries(selection.getAttributes()),
        firstPosition: selection.getFirstPosition(),
        lastPosition: selection.getLastPosition(),
        value,
      });

      model.insertObject(field, null, null, { setSelection: 'after' });
    });
  }

  refresh() {
    const { model } = this.editor;
    const { selection } = model.document;

    this.isEnabled = model.schema.checkChild(
      (selection?.focus ?? {}).parent as SchemaContextDefinition,
      'field',
    );
  }
}
